import { packageName, packageVersion } from '../../constants';
export var NOTIFICATION_SOURCE = 'notificationList';
export var NOTIFICATION_COMPONENT = 'notificationList';

/**
 * @returns Analytic attributes that are inserted into all event attributes
 */
export var defaultAnalyticsContextData = {
  source: NOTIFICATION_SOURCE,
  component: NOTIFICATION_COMPONENT,
  packageName: packageName,
  packageVersion: packageVersion
};